import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { FormlyModule } from "@ngx-formly/core";
import { AddOrEditNavigatorContactComponent } from "./add-or-edit-navigator-contact/add-or-edit-navigator-contact.component";
import { NavigatorContactsComponent } from "./navigator-contacts/navigator-contacts.component";
import { FlexModule } from "@vp/shared/directives/flex";

@NgModule({
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: "navigator-contacts",
          component: NavigatorContactsComponent
        }
      ]
    }),
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    FlexModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule
  ],
  exports: [NavigatorContactsComponent],
  declarations: [NavigatorContactsComponent, AddOrEditNavigatorContactComponent]
})
export class NavigatorContactsModule {}
